(function() {
  'use strict';
  var latin_map = {
  'á': 'a',
  'â': 'a',
  'ä': 'a',
  'ȧ': 'a',
  'à': 'a',
  'ã': 'a',
  'é': 'e',
  'ê': 'e',
  'ė': 'e',
  'è': 'e',
  'í': 'i',
  'î': 'i',
  'ï': 'i',
  'ì': 'i',
  'ĩ': 'i',
  'ó': 'o',
  'ô': 'o',
  'ö': 'o',
  'ȯ': 'o',
  'ò': 'o',
  'õ': 'o',
  'ú': 'u',
  'û': 'u',
  'ü': 'u',
  'ù': 'u',
  'ũ': 'u',
  };
  String.prototype.latinize = function() {
    return this.toLowerCase()
    .replace(/[^A-Za-z0-9]/g, function(x) {
      return latin_map[x] || x;
    });
  };
}());